export enum PageContext {
    CONQUER,
    CONQUER_PLUS,
    CONQUER_POS,
    EL_PROFESSOR,
    UNNA,
    WOL,
    IA_BUILDER,
    MBA_IA_BUSINESS
}

const urlParams = new URLSearchParams(window.location.search);
const contextParam = urlParams.get('ctx') || 'default';
const host = window.location.host;
const context = (() => {
    if (host.includes('pos')) {
        return PageContext.CONQUER_POS;
    }
    if (host.includes('plus')) {
        return PageContext.CONQUER_PLUS;
    }
    if (host.includes('elprofessor')) {
        return PageContext.EL_PROFESSOR;
    }
    if (host.includes('unna')) {
        return PageContext.UNNA;
    }
    if (host.includes('wol')) {
        return PageContext.WOL;
    }
    if (host.includes('iabuilder')) {
        return PageContext.IA_BUILDER;
    }
    if (host.includes('mbaia')) {
        return PageContext.MBA_IA_BUSINESS;
    }
    switch (contextParam) {
        case 'plus': return PageContext.CONQUER_PLUS;
        case 'pos': return PageContext.CONQUER_POS;
        case 'elprofessor': return PageContext.EL_PROFESSOR;
        case 'unna': return PageContext.UNNA;
        case 'wol': return PageContext.WOL;
        case 'iabuilder': return PageContext.IA_BUILDER;
        case 'mbaia': return PageContext.MBA_IA_BUSINESS;
        default: return PageContext.CONQUER;
    }
})();

export default function usePageContext() {
    return { context }
}